import { Empty } from 'google-protobuf/google/protobuf/empty_pb'
import { EvidenceServicePromiseClient } from '@trustero/trustero-api-web/lib/evidence/service_grpc_web_pb'
import { useAuthorizedGrpcClient } from 'src/adapter'

/**
 * Collect evidence from every enabled receptor in the account.
 *
 * Replaces the old Testing.RunAccountTests, which scanned receptors and then
 * ran the automated control tests. Those tests are retired, so this is the scan
 * alone -- the same one the evidence-collection schedule runs.
 */
export const useScanAllReceptors = (): (() => Promise<void>) => {
  const evidenceClient = useAuthorizedGrpcClient(EvidenceServicePromiseClient)
  return async () => {
    await evidenceClient.scanAllReceptors(new Empty())
  }
}
